import { arrayToSimpleObj } from '../utils';

export const matchedTypeOptions = [
  {
    text: 'All',
    value: '-',
  },
  {
    text: 'By Title',
    value: 'only title',
  },
  {
    text: 'By Content',
    value: 'only content',
  },
];

export const matchedTypeMap = arrayToSimpleObj(matchedTypeOptions);
